import { render } from "./PrismaDiagram3.vue?vue&type=template&id=3c486aa8"
import script from "./PrismaDiagram3.vue?vue&type=script&lang=js"
export * from "./PrismaDiagram3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__